import SelectedConditions from "./SelectedConditions";

export default SelectedConditions;
